// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b11518c","239":"3c2df57e","453":"306d8b65","732":"75d3b6b4"}[chunkId] + ".chunk.js";
};